import React, { useEffect, useState } from "react";
import Spinner from "../../Spin/Spinner";
import { getRefundAttemptsByException } from "../../../config/LiveApi";
import { useSelector } from "react-redux";

export default function PaymentDrawer({
  paymentExceptionId,
  onClose,
}) {
  const [loading, setLoading] = useState(false);
  const [attempts, setAttempts] = useState([]);
  const token = useSelector((state) => state.userReducer.token);

  useEffect(() => {
    fetchAttempts();
  }, [paymentExceptionId]);

  const fetchAttempts = async () => {
    try {
      setLoading(true);

      const response = await getRefundAttemptsByException(token,
        paymentExceptionId
      );

      setAttempts(response || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={styles.overlay} onClick={onClose} />

      <div style={styles.drawer}>
        <div style={styles.header}>
          <h3 style={styles.title}>Refund Activity</h3>

          <button
            style={styles.closeButton}
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {loading ? (
          <Spinner />
        ) : attempts.length === 0 ? (
          <div style={styles.emptyState}>
            No refund attempts found
          </div>
        ) : (
          <div style={styles.timeline}>
            {attempts.map((item, index) => (
              <div key={item.id || index} style={styles.card}>
                <div style={styles.cardHeader}>
                  <span
                    style={{
                      ...styles.status,
                      ...(item.status === "SUCCESS"
                        ? styles.success
                        : item.status === "FAILED"
                        ? styles.failed
                        : styles.pending),
                    }}
                  >
                    {item.status}
                  </span>

                  <span style={styles.date}>
                    {new Date(
                      item.createdAt
                    ).toLocaleString("en-IN")}
                  </span>
                </div>

                <div style={styles.info}>
                  <p>
                    <strong>Amount:</strong> ₹{item.amount}
                  </p>

                  <p>
                    <strong>Mode:</strong> {item.mode}
                  </p>

                  <p>
                    <strong>Reference:</strong>{" "}
                    {item.payoutReferenceId || "-"}
                  </p>

                  <p>
                    <strong>Order Id:</strong>{" "}
                    {item.requestOrderId || "-"}
                  </p>

                  <p>
                    <strong>Message:</strong>{" "}
                    {item.responseMessage || "-"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.35)",
    zIndex: 999,
  },

  drawer: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "600px",
    maxWidth: "100%",
    height: "100vh",
    background: "#fff",
    zIndex: 1000,
    overflowY: "auto",
    boxShadow: "-5px 0 20px rgba(0,0,0,0.12)",
  },

  header: {
    position: "sticky",
    top: 0,
    background: "#fff",
    padding: "18px 20px",
    borderBottom: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: 600,
  },

  closeButton: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: "20px",
  },

  timeline: {
    padding: "20px",
  },

  card: {
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    padding: "16px",
    marginBottom: "14px",
    background: "#fff",
  },

  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12px",
  },

  status: {
    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 600,
  },

  success: {
    background: "#dcfce7",
    color: "#15803d",
  },

  failed: {
    background: "#fee2e2",
    color: "#dc2626",
  },

  pending: {
    background: "#fef3c7",
    color: "#d97706",
  },

  date: {
    fontSize: "12px",
    color: "#64748b",
  },

  info: {
    fontSize: "14px",
    lineHeight: "1.8",
  },

  emptyState: {
    textAlign: "center",
    padding: "40px",
    color: "#64748b",
  },
};